import React from "react";

export function Loader({ label = "Loading…", full = false }) {
  return (
    <div className={`flex items-center justify-center gap-3 text-slate-500 ${full ? "min-h-[60vh]" : "py-16"}`}>
      <span className="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-teal-600" />
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
}
